import axios from "axios"
import { usePrevetAPI, RecentSearch } from "./usePrevetAPI"
import { useState, useCallback } from "react"
import { toast } from "react-toastify"

export function useFetchRecentSearch() {
  const { getRecentSearch } = usePrevetAPI()
  const [recentSearchData, setRecentSearchData] = useState<
    RecentSearch[] | undefined
  >([])
  const [getRecentSearchLoading, setGetRecentSearchLoading] = useState(false)
  const [getRecentSearchError, setGetRecentSearchError] = useState<
    string | undefined
  >()

  async function fetchRecentSearch() {
    setGetRecentSearchLoading(true)
    setRecentSearchData(undefined)
    setGetRecentSearchError(undefined)
    try {
      const response = await getRecentSearch()
      if (response) {
        setRecentSearchData(response)
      }
    } catch (err: unknown) {
      const message = "Unable to load recent search."
      setGetRecentSearchError(message)
      if (axios.isAxiosError(err)) {
        toast.warn(message, {
          position: "bottom-right",
          autoClose: 8000,
        })
      }
    } finally {
      setGetRecentSearchLoading(false)
    }
  }

  return {
    recentSearchData,
    fetchRecentSearch: useCallback(fetchRecentSearch, []),
    getRecentSearchLoading,
    getRecentSearchError,
  }
}
